import { Injectable } from "@angular/core";

import { RouteMappingService } from "./route-mapping.service";

@Injectable({
  providedIn: "root"
})
export class ApiObfuscationInitService {
  private initialized = false;

  constructor(private routeMapping: RouteMappingService) {}

  async initialize(): Promise<void> {
    if (this.initialized) {
      return;
    }

    try {
      await this.routeMapping.initialize();
      this.initialized = true;
    } catch (error) {
      console.error("Failed to initialize API obfuscation", error);
      this.initialized = true;
    }
  }
}
